/**
 * @author: subhasish.ghosh@zoom.us
 */

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const SearchParamsManager = ({ searchParamDefaults }) => {
  const [urlSearchParams, setURLSearchParams] = useSearchParams();

  useEffect(() => {
    const nonDefaultParams = Array.from(urlSearchParams.keys()).filter(
      (param) => !searchParamDefaults.includes(param?.toLowerCase())
    );

    if (nonDefaultParams.length) {
      nonDefaultParams.forEach((param) => urlSearchParams.delete(param));
      setURLSearchParams(urlSearchParams);
    }
  }, [searchParamDefaults, urlSearchParams, setURLSearchParams]);

  return null;
};

export default SearchParamsManager;
